import React, {useCallback} from 'react'
import MailIcon from '@mui/icons-material/Mail'
import Badge from '@mui/material/Badge';
import {useTheme} from '@mui/material'
import {useDispatch, useSelector} from 'react-redux';
import {selNotiAmountUnread} from 'module/Noti/selector/NotiSelector';
import {notiDrawerOpenAction} from 'module/Noti/action/NotiDrawerAction';
import {cssBottomBadge} from 'component/BottomBadge'
import {css} from '@emotion/react'

export const NotiButton = React.memo(() => {
	const theme = useTheme()
	const cssRoot = css`
		display: inline-flex;
		margin: ${theme.spacing(0, 2)};
		cursor: pointer;

		&:hover {
			color: ${theme.palette.secondary.light};
		}
	`
	const cssIcon = css`
		transform: scale(1, 0.8);
	`
	const unreadAmount = useSelector(selNotiAmountUnread);
	const dispatch = useDispatch();
	const onClickOpenNotiDrawer = useCallback(() => dispatch(notiDrawerOpenAction(true)), [dispatch]);
	return (
		<div css={cssRoot} onClick={onClickOpenNotiDrawer}>
			<Badge
				css={cssBottomBadge}
				badgeContent={unreadAmount}
				invisible={!unreadAmount}
				color={'secondary'}
			>
				<MailIcon css={cssIcon}/>
			</Badge>
		</div>
	);
});